import { useState, useEffect } from 'react'
import { detectUserTimezone, getCommonTimezones, getCurrentTimezoneOffset, formatTimezoneOffset } from '@/utils/timezone'

export interface TimezoneInfo {
    timezone: string
    displayName: string
    offset: string
    offsetMinutes: number
}

export function useTimezone() {
    const [timezoneInfo, setTimezoneInfo] = useState<TimezoneInfo | null>(null)
    const [isDetecting, setIsDetecting] = useState(true)

    const calculateTimezoneInfo = () => {
        try {
            const detectedTimezone = detectUserTimezone()
            const commonTimezones = getCommonTimezones()
            const commonTimezone = commonTimezones.find(tz => tz.value === detectedTimezone)

            // Get current timezone offset (includes DST)
            const offsetMinutes = getCurrentTimezoneOffset()
            const offsetString = formatTimezoneOffset(offsetMinutes)

            return {
                timezone: detectedTimezone,
                displayName: commonTimezone?.label || detectedTimezone,
                offset: offsetString,
                offsetMinutes
            }
        } catch (error) {
            console.warn('Failed to detect timezone:', error)
            return {
                timezone: 'UTC',
                displayName: 'UTC (Coordinated Universal Time)',
                offset: 'UTC+00:00',
                offsetMinutes: 0
            }
        }
    }

    useEffect(() => {
        const detectTimezone = () => {
            setTimezoneInfo(calculateTimezoneInfo())
            setIsDetecting(false)
        }

        detectTimezone()
    }, [])

    return {
        timezoneInfo,
        isDetecting,
        detectTimezone: () => {
            setIsDetecting(true)
            setTimezoneInfo(calculateTimezoneInfo())
            setIsDetecting(false)
        },
        // Helper function to get current offset
        getCurrentOffset: () => getCurrentTimezoneOffset()
    }
}
